/* Siluetopía · Caja de marionetas de regalo: 1 por pedido.
   Después de cualquier cambio al carrito revisa que la caja quede en 1 si hay
   libros y que se quite si ya no hay ninguno. */
(function () {
  if (window.__stRegalo) return;
  window.__stRegalo = true;
  var REGALO = 51496118518048;
  var MARCA = 'X-St-Regalo';
  var fetchOriginal = window.fetch.bind(window);
  var ocupado = false, pendiente = false, reloj;

  function esCambioDeCarrito(url) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url); }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var propio = init && init.headers && init.headers[MARCA];
    var p = fetchOriginal(input, init);
    if (!propio && esCambioDeCarrito(url)) p.then(function () { programar(); }, function () {});
    return p;
  };

  function programar() { clearTimeout(reloj); reloj = setTimeout(revisar, 200); }

  function enviar(ruta, cuerpo) {
    var h = { 'Content-Type': 'application/json', Accept: 'application/json' }; h[MARCA] = '1';
    return fetchOriginal(ruta, { method: 'POST', headers: h, body: JSON.stringify(cuerpo) });
  }

  function revisar() {
    if (ocupado) { pendiente = true; return; }
    ocupado = true;
    fetchOriginal('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var libros = 0, regalos = [];
        c.items.forEach(function (it) {
          if (it.variant_id === REGALO) regalos.push(it); else libros += it.quantity;
        });
        var objetivo = libros > 0 ? 1 : 0;
        var total = regalos.reduce(function (a, it) { return a + it.quantity; }, 0);
        if (total === objetivo && regalos.length <= 1) return false;
        var cambios = {};
        regalos.forEach(function (it, i) { cambios[it.key] = i === 0 ? objetivo : 0; });
        return enviar('/cart/update.js', { updates: cambios }).then(function () { return true; });
      })
      .then(function (cambio) { if (cambio) refrescar(); })
      .catch(function () {})
      .then(function () { ocupado = false; if (pendiente) { pendiente = false; programar(); } });
  }

  // Vuelve a dibujar el carrito con la cantidad corregida
  function refrescar() {
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var d = document.querySelector('cart-drawer');
    var ids = d && typeof d.getSectionsToRender === 'function'
      ? d.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    fetchOriginal(location.pathname + '?sections=' + ids.join(','), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (secs) {
        Object.keys(secs).forEach(function (id) {
          if (!secs[id]) return;
          var html = new DOMParser().parseFromString(secs[id], 'text/html');
          var nuevo = html.querySelector('#CartDrawer');
          if (nuevo) {
            var viejo = document.querySelector('#CartDrawer');
            if (viejo) viejo.innerHTML = nuevo.innerHTML;
            if (d) d.classList.toggle('is-empty', !!html.querySelector('cart-drawer.is-empty, .drawer__inner-empty'));
          } else {
            var el = document.getElementById(id), src = html.getElementById('shopify-section-' + id);
            if (el && src) el.innerHTML = src.innerHTML;
          }
        });
        bloquear();
      })
      .catch(function () {});
  }

  // En la página del carrito la caja no se puede cambiar de cantidad
  function bloquear() {
    document.querySelectorAll('input[data-quantity-variant-id="' + REGALO + '"]').forEach(function (inp) {
      var fila = inp.closest('tr, .cart-item'); if (!fila || fila.dataset.stRegalo) return;
      fila.dataset.stRegalo = '1';
      fila.querySelectorAll('.cart-item__quantity, .cart-item__quantity-wrapper, quantity-input, quantity-popover').forEach(function (q) { q.style.setProperty('display', 'none', 'important'); });
      fila.querySelectorAll('cart-remove-button, .cart-remove-button').forEach(function (b) { b.style.display = 'none'; });
      var nombre = fila.querySelector('.cart-item__name');
      if (nombre && !fila.querySelector('.st-regalo-tag')) {
        var t = document.createElement('span'); t.className = 'st-regalo-tag';
        t.textContent = 'Regalo · 1 por pedido';
        t.style.cssText = 'display:inline-block;margin-left:8px;background:#2f7a3e;color:#fff;font-size:11px;font-weight:700;padding:2px 8px;border-radius:99px;vertical-align:middle;';
        nombre.after(t);
      }
    });
  }

  function iniciar() { bloquear(); revisar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
